import ytPlayBtn from "../../../../../assets/images/YouTube_play_button.svg";

export const AboutUsPreviewTab = ({ responseData, PlayVimeoVideoHandler, convertToStandardURL, PlayVideoHandler, loading, CompLoader, color }) => {
 

  const ShowCustomTitleHandler = (value) => {
    if (value === "WhyDo") {
        return "Why we exist";
    }
    if (value === "howDo") {
        return "How we help";
    }
    if (value === "whatDo") {
        return "What we do";
    }
    return value;
};



  return (
    <div className="rowBody preview-tab-container">
      {loading ? (
        <CompLoader />
      ) :
        responseData &&
          responseData.length > 0 ? (
          responseData.map((data, i) => {
            return (
              <div
                className="preview-item-container"
                style={{ borderLeft: `5px solid ${color[i % 7]}` }}
              >

                <div className="gutter-row tabContent" span={15}>
                  {ShowCustomTitleHandler(data?.title || data?.assetTitle || data?.subTitle || data?.experienceOfWorkTitle)}
                </div>
                <div className="gutter-row" span={9}>
                  {data.mediaLink?.mediaType === "SOCIAL_MEDIA" ? (
                    <div
                      className="sliderImg videoOverlay"
                      onClick={PlayVideoHandler.bind(
                        this,
                        data.mediaLink?.url,
                        data.mediaLink?.mediaType
                      )}
                    >
                      {(() => {
                        const standardURL = convertToStandardURL(
                          data.mediaLink?.url
                        );
                        const videoID = new URLSearchParams(
                          new URL(standardURL).search
                        ).get("v");
                        return (
                          <>
                            <img
                              src={`https://img.youtube.com/vi/${videoID}/hqdefault.jpg`}
                              style={{ objectFit: "cover" }}
                              alt=""
                              className="video-preview-image"
                            />
                            <img
                              className="ytBtnOverlay"
                              src={ytPlayBtn}
                              alt=""
                              onClick={() =>
                                PlayVideoHandler(
                                  data.mediaLink?.url,
                                  data.mediaLink?.mediaType
                                )
                              }
                            />
                          </>
                        );
                      })()}
                    </div>
                  ) : data?.mediaLink?.mediaType ===
                    "VIMEO_MEDIA" ? (
                    <div
                      className="sliderImg videoOverlay"
                      onClick={PlayVimeoVideoHandler.bind(
                        this,
                        data.mediaLink?.url,
                        data.mediaLink?.mediaType
                      )}
                    >
                      <img
                        src={`https://vumbnail.com/${data.mediaLink.url.split("/")[4]
                          }.jpg`}
                        alt=""
                        className="video-preview-image"
                      />
                      <img
                        className="ytBtnOverlay"
                        src={ytPlayBtn}
                        alt=""
                        onClick={PlayVideoHandler.bind(
                          this,
                          data.mediaLink?.url,
                          data.mediaLink?.mediaType
                        )}
                      />
                    </div>
                  ) : data?.aboutUsTeamDataOutPut?.image?.mediaType === "IMAGE" ||
                    data?.aboutUsTeamDataOutPut?.image?.mediaType === "GIF" ||
                    data?.mediaLink?.mediaType==='IMAGE' ||
                    data?.mediaLink?.mediaType==='GIF' ||
                    data?.awardsLogos?.mediaType === 'IMAGE' ? (
                    <div className="sliderImg-alt">
                      <img
                        src={data?.aboutUsTeamDataOutPut?.image?.url || data?.mediaLink?.url ||data?.awardsLogos?.url }
                        alt=""
                        className="preview-img"
                      />
                    </div>
                  ) : (
                    <div className="sliderImg-alt">
                      <div className="preview-img"></div>
                    </div>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <div className="background-container">
            <span>Nothing here at the moment</span>
          </div>
        )}
    </div>


  )


}
